var map = {
	"./food_burger.png": "77d4",
	"./food_coffe.png": "c486",
	"./food_drink.png": "37fb",
	"./food_fries.png": "820d",
	"./food_hotdog.png": "7f01",
	"./food_icecream.png": "0e92",
	"./food_pizza.png": "89e8",
	"./food_sushi.png": "d4ec0",
	"./food_taco.png": "4eff",
	"./food_thai.png": "d3e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd3c";